/**
 * Hook for creating Stripe subscriptions
 * Handles the subscription creation API call and returns payment details
 */

import { useMutation } from 'react-query';
import { BASE_API_URL } from '@env';
import { useUserStore } from '~providers/userStore/zustand';
import axios from 'axios';

export interface CreateSubscriptionRequest {
  plan_id: string;
  payment_method_id?: string; // Optional: pre-fill with saved card
}

export interface SubscriptionPaymentDetails {
  subscription_id: string;
  client_secret: string;
  customer_id: string;
}

export const useCreateSubscription = () => {
  return useMutation<SubscriptionPaymentDetails, Error, CreateSubscriptionRequest>(
    async (payload: CreateSubscriptionRequest) => {
      const token = useUserStore.getState().token;

      if (!token) {
        throw new Error('No authentication token available');
      }

      console.log('🔍 useCreateSubscription: Making API call');
      console.log('🔍 useCreateSubscription: API URL:', `${BASE_API_URL}stripe/subscription/create-subscription-rn`);
      console.log('🔍 useCreateSubscription: Payload:', payload);

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      };

      try {
        const response = await axios.post(
          `${BASE_API_URL}stripe/subscription/create-subscription-rn`,
          payload,
          config,
        );

        console.log('✅ useCreateSubscription: Success response:', response.data);

        return response.data as SubscriptionPaymentDetails;
      } catch (error) {
        console.error('❌ useCreateSubscription: API Error:', error);
        if (axios.isAxiosError(error)) {
          const errorMessage =
            error.response?.data?.message ||
            error.response?.data?.detail ||
            error.message ||
            'Failed to create subscription';
          throw new Error(errorMessage);
        }
        throw error;
      }
    },
  );
};
